<template>

  <div>
      <b-card>
      <b-form @submit.prevent="onSubmit">

      <!-- Media -->
      <b-media class="mb-2">
        <template #aside>
          <b-avatar ref="previewEl" :src="key.avatar" :text="avatarText(key.fullName)" :variant="`light-${resolveUserRoleVariant}`" size="90px" rounded />
        </template>
        <h4 class="mb-1"> {{ key.fullName }} </h4>
      </b-media>

      <!-- Customer Info: Input Fields -->
        <b-row class="mb-3">

          <!-- Field: Username -->
          <b-col cols="12" md="4" >
            <b-form-group :label="$t('Username')" label-for="username" >
              <b-form-input id="username" v-model="key.username" />
            </b-form-group>
          </b-col>

          <!-- Field: Name -->
          <b-col cols="12" md="4" >
            <b-form-group :label="$t('Name')" label-for="name" >
              <b-form-input id="name" v-model="key.name" />
            </b-form-group>
          </b-col>

          <!-- Field: Surname -->
          <b-col cols="12" md="4" >
            <b-form-group :label="$t('Surname')" label-for="surname" >
              <b-form-input id="surname" v-model="key.surname" />
            </b-form-group>
          </b-col>

          <!-- Field: Email -->
          <b-col cols="12" md="4" >
            <b-form-group :label="$t('Email')" label-for="email" >
              <b-form-input id="email" v-model="key.email" type="email" />
            </b-form-group>
          </b-col>

          <!-- Field: Groups -->
          <b-col cols="12" md="4" >
            <b-form-group :label="$t('Grupos')" label-for="username" >
              <b-form-input disabled :value="groups"/>
            </b-form-group>
          </b-col>
        </b-row>

      <!-- Action Buttons -->
      <b-button variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </b-button>
      <b-button variant="outline-secondary" type="reset" :to="{ name:'home' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{ $t('Cancel') }} </b-button>
    </b-form>

    </b-card>

    <b-card>

      <b-form>
        <h4 class="mb-1"> Cambiar contraseña </h4>

        <b-row>
          <b-col cols="12" md="4" >
                <b-form-group :label="$t('Old password')" label-for="password" >
                  <b-form-input id="oldPassword" v-model="oldPass" type="password" />
                </b-form-group>
          </b-col>
          <b-col cols="12" md="4" >
                <b-form-group :label="$t('New password')" label-for="password" >
                  <b-form-input id="newPassword" v-model="newPass" type="password" />
                </b-form-group>
          </b-col>
          <b-col cols="12" md="4" >
                <b-form-group :label="$t('Repeat password')" label-for="password" >
                  <b-form-input id="newPasswordRepeat" v-model="newPassRepeat" type="password" />
                </b-form-group>
          </b-col>
        </b-row>
      <b-button variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmitModifyPass"> {{ $t("Modify") }} </b-button>
      </b-form>


    </b-card>
  </div>
</template>

<script>
import { BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import axios from '@axios'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'

export default {
    components: { BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormCheckboxGroup },
    data() {
        return {
            key: {},
            groups: "",
            oldPass: "",
            newPass:"",
            newPassRepeat: ""
        }
    },
    created(){
        axios
            .get(`/user/profile`)
            .then(response => {
                this.key = response.data.user;

                this.key.groups.forEach(function callback(group, index) {
                  if(this.key.groups.length == index + 1){
                    this.groups += group.name
                  }else{
                    this.groups += group.name + " | "
                  }
                }, this)
            })


    },
    methods: {
        onSubmit() {
          axios.post('/user/updateProfile', JSON.parse(JSON.stringify(this.key)) )
          .then(response => {
              this.$router.push({ name: 'home' })
          })
          .catch(error => {
              this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                  title: `Error`,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                  text: `${i18n.t("Cant update profile")}`,
             },
            })
          })

        },
        onSubmitModifyPass () {
          if (this.newPass==this.newPassRepeat) {
            let data = {
                old: this.oldPass,
                new: this.newPass,
                repeat: this.newPassRepeat
            }
            axios.post('/user/update-password', JSON.parse(JSON.stringify(data)))
                .then(response => {
                    this.$router.push({ name: 'home' })
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Success',
                            icon: 'success',
                            variant: 'success',
                            text: `${i18n.t('Password updated')}`
                        }
                    })
                })
                .catch(error => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Error',
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            text: `${i18n.t('Can\'t update password')}`
                        }
                    })
                })
          } else {
            this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Error',
                            icon: 'AlertTriangleIcon',
                            variant: 'danger',
                            text: `${i18n.t('New passwords don\'t coincide')}`
                        }
                    })
          }
        }

    },
    computed: {
        resolveUserRoleVariant() {
            let role = this.key.role
            if (role === 'Administrador') return 'primary'
            if (role === 'Superadministrador') return 'primary'
            if (role === 'Empleado') return 'primary'
            return 'primary'
        }
    },
    setup (props) {
        const statusOptions = [
            { label: 'Active', value: "1" },
            { label: 'Inactive', value: "0" },
        ]

        const refInputEl = ref(null)
        // const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => { this.key.avatar = base64 })
        return {
            statusOptions,
            avatarText,
            refInputEl,
            // inputImageRenderer
        }
    }

}
</script>

<style>

</style>
